export default "__VITE_ASSET__B4xjf4ij__"